module.exports = __webpack_public_path__ + "img/zhiyuanzheicon1.1608600964781.png";